import routerOptions0 from "/src/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.13.14_db0@0.3.2_eslint@9.23.0_jiti@2.4_33a656d194c8319ddc273ac61446e476/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}